module.exports = __webpack_public_path__ + "img/Key Metrics.83e55a08.svg";